module.exports = "/img/_/_/_/assets/images/creeper/battle/uncommon//8.jpg?7abc12a7dcc6885995ed170a0c502c0a";